export default "__VITE_ASSET__cde7c9b9__"